export default __webpack_public_path__ + "static/media/map1.3eee823a.png";